// extracted by mini-css-extract-plugin
export default {"home":"PharmacyPage_home__nIJM8","services":"PharmacyPage_services__Ra+zM","img":"PharmacyPage_img__grmKp"};